var __jsx = React.createElement;
import React from "react";
import { Icon } from "@syarahtech/ui";
import { copyTextToClipboard } from "@/utils/common";
function CopyableField(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onCopy = _ref.onCopy;
  var handleCopy = function handleCopy() {
    copyTextToClipboard(value);
    onCopy === null || onCopy === void 0 ? void 0 : onCopy();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full self-stretch mb-4 p-4 bg-slate-100 rounded-md inline-flex flex-col justify-start items-start gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full inline-flex justify-start items-center gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 justify-start text-[#6C7A8D] text-base font-bold"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start items-center gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "font-bold text-[#484848] px-1"
  }, value), /*#__PURE__*/React.createElement("div", {
    onClick: handleCopy,
    className: "cursor-pointer"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--content-copy-rounded",
    className: "text-[#154f9c]",
    width: 6,
    height: 6
  })))));
}
export default CopyableField;